<template>
    <div class="px-6 surface-overlay relative">
        <div class="py-3 lg:py-3 px-6 flex align-items-center justify-content-between lg:static">
            <img src="images/blocks/logos/logo.simplyinvesting.rev2.png" alt="Simply Investing" height="50"
                 class="mr-0 lg:mr-6">
            <div class="flex align-items-center">
                <a v-ripple class="cursor-pointer block lg:hidden text-700 mr-5 p-ripple"
                   v-styleclass="{ selector: '#navbar-sub-7', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                    <i class="pi pi-ellipsis-v text-2xl"></i>
                </a>
                <a v-ripple class="cursor-pointer block lg:hidden text-700 p-ripple"
                   v-styleclass="{ selector: '#navbar-7', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                    <i class="pi pi-bars text-4xl"></i>
                </a>
            </div>
            <div id="navbar-sub-7"
                 class="hidden lg:block absolute lg:static lg:w-auto w-full surface-overlay left-0 top-100 z-1 shadow-2 lg:shadow-none">
                <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row border-top-1 surface-border lg:border-top-none">
                    <!--                    <li v-show="this.userStore.user.rights != 'C'">-->
                    <li>
                        <a @click="processHelp" v-tooltip="'Getting Started'" v-ripple
                           class="flex px-6 p-3 lg:px-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-question-circle text-base lg:text-2xl mr-2 lg:mr-0"></i>
                            <span class="block lg:hidden font-medium">Help</span>
                        </a>
                    </li>
                    <!--                    <li v-show="this.userStore.user.rights != 'C'">-->
                    <li>
                        <a @click="processConfiguration" v-tooltip="'User Settings'" v-ripple
                           class="flex px-6 p-3 lg:px-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-cog text-base lg:text-2xl mr-2 lg:mr-0"></i>
                            <span class="block lg:hidden font-medium">Configuration</span>
                        </a>
                    </li>
<!--                    <li>-->
<!--                        <a @click="processProfile" v-ripple-->
<!--                           class="flex px-6 p-3 lg:px-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
<!--                            <i class="pi pi-id-card text-base lg:text-2xl mr-2 lg:mr-0"></i>-->
<!--                            <span class="block lg:hidden font-medium">Profile</span>-->
<!--                        </a>-->
<!--                    </li>-->
<!--                    <li>-->
<!--                        <a @click="processNotifications" v-ripple-->
<!--                           class="flex px-6 p-3 lg:px-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
<!--                            <i class="pi pi-bell text-base lg:text-2xl mr-2 lg:mr-0" v-badge.danger></i>-->
<!--                            <span class="block lg:hidden font-medium">Notifications</span>-->
<!--                        </a>-->
<!--                    </li>-->
                    <li>
                        <a @click="processLogout" v-tooltip="'Logout'" v-ripple
                           class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-sign-out text-base lg:text-2xl mr-2 lg:mr-0"></i>
                            <span class="block lg:hidden font-medium">Logout</span>
                        </a>
                    </li>

                </ul>
            </div>
        </div>
        <div id="navbar-7"
             class="py-3 hidden lg:block absolute lg:static lg:w-auto w-full surface-overlay left-0 top-100 z-1 border-top-1 surface-border">
            <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                <!--                <li v-show="this.userStore.user.rights != 'C'">-->
                <li>
                    <a @click="processOverview" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Home</span>
                    </a>
                </li>

                <!--                <li v-show="this.userStore.user.rights != 'C'">-->
                <li>
                    <a @click="processPlan" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Plan</span>
                    </a>
                </li>

                <li>
                    <a @click="processTrack" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-calendar mr-2"></i>
                        <span>Track</span>
                    </a>
                </li>

                <!--                <li v-show="this.userStore.user.rights != 'C'">-->
                <li>
                    <a @click="processAchieve" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-tags mr-2"></i>
                        <span>Achieve</span>
                    </a>
                </li>

                <li v-show="this.userStore.user.rights === 'S'">
                    <a @click="processAdmin" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-money-bill mr-2"></i>
                        <span>Admin</span>
                    </a>
                </li>

                <!--                <li v-show="this.userStore.user.rights != 'C'">-->
                <!--                    <a @click="processSearch" v-ripple-->
                <!--                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
                <!--                        <i class="pi pi-search mr-2"></i>-->
                <!--                        <span>Search</span>-->
                <!--                    </a>-->
                <!--                </li>-->

<!--                <li v-show="this.userStore.user.rights != 'C'">-->
                <li>
                    <a @click="processCourse" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-shopping-cart mr-2"></i>
                        <span>Course</span>
                    </a>
                </li>

                <li>
                    <a @click="processMemberGroup" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-tags mr-2"></i>
                        <span>Community</span>
                    </a>
                </li>

            </ul>
        </div>
    </div>
</template>


<script>
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";
import AuthenticationService from "@/service/AuthenticationService";

export default {
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        UserService.getUserPing()
            .then(data => {
                console.log("[MenuSiModuleMain][mounted] System is active. Data = ", data);
            })
            .catch(e => {
                // console.log("[MenuSiModuleMain][mounted] System is NOT active.");
                console.log("[MenuSiModuleMain][mounted] Error = ", e);

                this.userStore.clearUser;
                // this.$router.push("login");
                this.$router.push('/siLogin');
            });

        if (this.userStore.user === undefined) {
            console.log("[MenuSiModuleMain][mounted] User is NOT defined.");

            this.userStore.clearUser;
            this.$router.push('/siLogin');
            // this.$router.push('login');
        } else {
            console.log("[MenuSiModuleMain][mounted] User is defined. this.userStore.userId = ", this.userStore.userId);
        }
    },
    methods: {
        async processLogout() {
            // console.log("[MenuSiModuleMain][processLogout] Beginning.");

            console.log("[MenuSiModuleMain][processLogout] this.userStore.username = ", this.userStore.username);
            const responseData = await AuthenticationService.signoutUser(this.userStore.username);
            console.log('[Login][handleLogin] Response = ', responseData);

            this.userStore.$reset();
            this.userStore.clearUser;
            window.location.href = "/#/siLogin";
            window.location.reload();
        },
        processProfile() {
            // window.location.href = "/#/siProfile";
            const current = window.location.hash;
            if (current === "#/siProfile") {
                window.location.reload();
            } else {
                window.location.href = "/#/siProfile";
            }
        },
        processNotifications() {
            // window.location.href = "/#/siNotifications";
            const current = window.location.hash;
            if (current === "#/siNotifications") {
                window.location.reload();
            } else {
                window.location.href = "/#/siNotifications";
            }
        },
        processHelp() {
            // window.location.href = "/#/siHelp";
            const current = window.location.hash;
            if (current === "#/siHelp") {
                window.location.reload();
            } else {
                window.location.href = "/#/siHelp";
            }
        },
        processConfiguration() {
            // window.location.href = "/#/siConfiguration";
            const current = window.location.hash;
            if (current === "#/siConfiguration") {
                window.location.reload();
            } else {
                window.location.href = "/#/siConfiguration";
            }
        },
        processOverview() {
            // window.location.href = "/#/siOverview";
            const current = window.location.hash;
            if (current === "#/siOverview") {
                // Force reload
                window.location.reload();
            } else {
                window.location.href = "/#/siOverview";
            }
        },
        processPlan() {
            // window.location.href = "/#/siPlan";
            const current = window.location.hash;
            if (current === "#/siPlan") {
                window.location.reload();
            } else {
                window.location.href = "/#/siPlan";
            }
        },
        processTrack() {
            // window.location.href = "/#/siTrack";
            const current = window.location.hash;
            if (current === "#/siTrack") {
                window.location.reload();
            } else {
                window.location.href = "/#/siTrack";
            }
        },
        processAchieve() {
            // window.location.href = "/#/siAchieve";
            const current = window.location.hash;
            if (current === "#/siAchieve") {
                window.location.reload();
            } else {
                window.location.href = "/#/siAchieve";
            }
        },
        processAdmin() {
            // window.location.href = "/#/siAdmin";
            const current = window.location.hash;
            if (current === "#/siAdmin") {
                window.location.reload();
            } else {
                window.location.href = "/#/siAdmin";
            }
        },
        processCourse() {
            // window.location.href = "/#/siCourse";
            const current = window.location.hash;
            if (current === "#/siCourse") {
                window.location.reload();
            } else {
                window.location.href = "/#/siCourse";
            }
        },
        processMemberGroup() {
            window.open("https://www.linkedin.com/groups/14562007/", '_blank');
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
